import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    TextField,
    Typography
} from "@mui/material";
import {TokenWithInvitation} from "../entities/token-with-invitation";
import {useState} from "react";

export interface TokenGiveAccessDialogProps {
    open: boolean;
    onClose: (token?: TokenWithInvitation) => void;
    availableStreams: { [key: string]: string };
    token?: TokenWithInvitation;
}

export const TokenGiveAccessDialog = (props: TokenGiveAccessDialogProps) => {

    const [email, setEmail] = useState("")
    const [firstname, setFirstname] = useState("")
    const [lastname, setLastname] = useState("")
    const [selectedStream, setSelectedStream] = useState("")

    const submitInfo = () => {
        if (props.token) {
            props.token.inviteeEmail = email
            props.token.inviteeFirstname = firstname
            props.token.inviteeLastname = lastname
            props.token.streamId = props.availableStreams[selectedStream]
            props.token.streamName = selectedStream
            props.onClose(props.token)
        } else {
            props.onClose()
        }
    }

    const mapStreamsToOptions = () => {
        if (props.availableStreams && Object.keys(props.availableStreams).length > 0) {
            return Object.entries<string>(props.availableStreams).map(entry => {
                    return <MenuItem value={entry[0]} key={entry[1]}>{entry[0]}</MenuItem>
                }
            )
        }
        return <></>
    }

    return props.token ? <Dialog
        open={props.open}
        onClose={() => props.onClose()}
    >
        <DialogTitle>Invite</DialogTitle>
        <DialogContent dividers>
            <Typography>
                You are going to invite a participant on the Academy. Please fill the form below to invite them.
            </Typography>
            <form>
                <TextField id="email" label="Invitee email" placeholder="email" required
                           helperText="Type the email of the invitee" fullWidth
                           value={email} onChange={(ev) => setEmail(ev.target.value)}/>
                <TextField id="firstname" label="Invitee firstname" placeholder="firstname" required
                           helperText="Type the firstname of the invitee" fullWidth
                           value={firstname} onChange={(ev) => setFirstname(ev.target.value)}/>
                <TextField id="lastname" label="Invitee lastname" placeholder="lastname" required
                           helperText="Type the lastname of the invitee" fullWidth
                           value={lastname} onChange={(ev) => setLastname(ev.target.value)}/>
                <TextField id="selectedStream" label="Course stream" select required
                           helperText="Select the stream of course for the invitee" fullWidth
                           value={selectedStream} onChange={(ev) => setSelectedStream(ev.target.value)}>
                    {props.availableStreams && mapStreamsToOptions()}
                </TextField>

            </form>
        </DialogContent>
        <DialogActions>
            <Button autoFocus onClick={() => props.onClose()} color="error">
                Cancel
            </Button>
            <Button onClick={() => submitInfo()} color="success"
                    disabled={!email || !firstname || !lastname || !selectedStream}>Invite</Button>
        </DialogActions>
    </Dialog> : <></>
}